// Keep this policy in sync with server/utils/sanitize-email.js.
// Strip bidi display controls, preserving international address characters.
const EMAIL_DIRECTION_MARKS = /[\u061C\u200E\u200F\u202A-\u202E\u2066-\u2069]/g;

export function sanitizeEmail(email) {
  return typeof email === 'string' ? email.replace(EMAIL_DIRECTION_MARKS, '').trim() : '';
}
